import React, { useEffect, useState } from 'react';
import JobMonitorCard from './JobMonitorCard';
import productionService from '../../service/production.service';

const JobMonitorResources = ({
  resource,
  getProductionById,
  onDragStart,
  onDrop,
  setRefetchResources,
  isDragging,
  dragOverData,
  setIsAttachmentDialogOpen,
  setAttachments,
  autoCompleteData,
  onFeedbackClick,
}) => {
  const { draggingItemId, setDraggingItemId } = isDragging;
  const { dragOverIndex, setDragOverIndex } = dragOverData;

  const scrollId = `scrollableDiv-${resource.id}`;
  const scrollSpeed = 100;
  const scrollThreshold = 150;

  const [extendedRows, setExtendedRows] = useState([]);

  useEffect(() => {
    loadInitialData();
  }, [resource]);

  const loadInitialData = () => {
    const baseOps = resource.productionOperation || [];
    const multiOps = (resource.productionOperationMultiResource || []).map((multiRes) => ({
      ...multiRes.productionOperation,
      isMultiResource: true,
      multiResourceId: multiRes.id,
    }));
    setExtendedRows([...baseOps.map((op) => ({ ...op, isMultiResource: false })), ...multiOps]);
  };

  const handleDragOver = (event, index) => {
    event.preventDefault();

    const container = event.currentTarget.closest('.custom-scrollbar');
    if (container) {
      const { top, bottom } = container.getBoundingClientRect();
      const mouseY = event.clientY;

      if (mouseY - top < scrollThreshold) {
        container.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
      } else if (bottom - mouseY < scrollThreshold) {
        container.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
      }
    }

    if (extendedRows[index]?.id === draggingItemId) {
      setDragOverIndex({ resourceId: null, index: null });
      return;
    }

    const draggingIndex = extendedRows.findIndex((op) => op.id === draggingItemId);
    if (draggingIndex === index || draggingIndex + 1 === index) {
      setDragOverIndex({ resourceId: null, index: null });
    } else {
      setDragOverIndex({ resourceId: resource.id, index });
    }
  };

  const handleDropInside = (event) => {
    event.preventDefault();

    const jobItem = JSON.parse(event.dataTransfer.getData('jobItem'));

    const fromIndex = extendedRows.findIndex((op) => op.id === jobItem.id);
    if (!extendedRows.some((op) => op.id === jobItem.id)) {
      onDrop(event, resource);
      setDragOverIndex(null);
      setDraggingItemId(null);
      return;
    }

    const toIndex = dragOverIndex.index;

    if (toIndex === null || fromIndex === toIndex) {
      setDragOverIndex(null);
      setDraggingItemId(null);
      return;
    }

    const reordered = reorderOperations(extendedRows, fromIndex, toIndex);

    const isSameOrder = extendedRows.every((op, idx) => op.id === reordered[idx].id);
    if (!isSameOrder) {
      const payload = reordered.map((item, idx) => ({
        id: item.id,
        visOrderY: idx + 1,
      }));

      productionService.updateVisOrderYBatch(payload).then(() => {
        setRefetchResources(true);
      });
    }

    setDragOverIndex(null);
    setDraggingItemId(null);
  };

  const reorderOperations = (operations, startIndex, endIndex) => {
    const result = Array.from(operations);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((operation, index) => ({
      ...operation,
      visOrderY: index + 1,
    }));
  };

  return (
    <div
      id={scrollId}
      className="flex flex-col max-h-[calc(100vh-140px)] min-h-[calc(100vh-140px)] bg-gray-100 overflow-y-auto custom-scrollbar"
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => handleDropInside(event)}
    >
      <div className="bg-white pl-2 text-center font-bold relative py-3 text-labelColor">
        <div className="text-xl">{resource.name}</div>
        <div>{resource.totalPlannedHours} óra</div>
      </div>

      <div className="p-2">
        {extendedRows.map((row, index) => (
          <div key={row.id}>
            {dragOverIndex?.resourceId === resource.id && dragOverIndex.index === index && (
              <div
                className="mb-3 rounded-md p-4 shadow-md bg-gray-300 border-2 border-gray-500"
                style={{ minHeight: '200px' }}
              ></div>
            )}
            <div onDragOver={(event) => handleDragOver(event, index)}>
              <JobMonitorCard
                data={row}
                getProductionById={getProductionById}
                onDragStart={onDragStart}
                type="RESOURCECOLUMN"
                setRefetchResources={setRefetchResources}
                setIsAttachmentDialogOpen={setIsAttachmentDialogOpen}
                setAttachments={setAttachments}
                autoCompleteData={autoCompleteData}
                onFeedbackClick={onFeedbackClick}
              />
            </div>
          </div>
        ))}

        {dragOverIndex?.resourceId === resource.id && dragOverIndex.index === extendedRows.length && (
          <div
            className="mb-3 rounded-md p-4 shadow-md bg-gray-300 border-2 border-gray-500"
            style={{ minHeight: '200px' }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default JobMonitorResources;
